<script setup>
import { HActionDialog } from '@/components/shared/atoms'

import HUserData from '../../menu/atoms/HUserData.vue'
import { HCertificationHeader } from '../atoms'
import HCertification from './HCertification.vue'

defineProps({
  show: {
    type: Boolean,
    default: false
  },
  context: {
    type: String,
    default: null
  },
  enforcingSignature: {
    type: Boolean,
    default: false
  },
  mini: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['close'])
const handleClose = result => {
  emit('close', result)
}
</script>

<template>
  <HActionDialog v-if="show">
    <template #header>
      <HCertificationHeader :enforcing-signature="enforcingSignature" />
    </template>
    <template #content>
      <div class="certification">
        <HUserData show-avatar />
        <HCertification
          :context="context"
          :enforcing-signature="enforcingSignature"
          @close="handleClose"
        />
        <div class="footer-links">
          <a
            class="bird__link"
            href="https://birdid.com.br/sobre-o-bird-id/"
            rel="noreferrer"
            target="_blank"
          >
            O que é Bird ID?
          </a>
          <img
            class="bird__icon"
            :src="require('@/assets/birdID.svg')"
            alt="Bird ID logo"
          />
        </div>
      </div>
    </template>
  </HActionDialog>
</template>

<style lang="scss" scoped>
@import '@/style/_non-rendering';
.certification {
  position: relative;
}
.bird {
  &__ink {
    @extend %body-small;
    margin-right: var(--gl-spacing-02);
    color: var(--gl-color-shades-magenta-60);
  }

  &__icon {
    width: 56px;
    height: 40px;
  }
}
.footer-links {
  display: flex;
  align-items: center;
  position: absolute;
  bottom: -3px;
  right: 0;
}
</style>
